import FormField from './form_field';

export default class DatepickerFormField extends FormField {
	_calendar;

	constructor(fieldProps = {}) {
		super(fieldProps);
	}

	get calendar() {
		return this._calendar;
	}

	set calendar(value) {
		this._calendar = value;
	}
}
